export { default } from './AppAdoptionHeader'
